import React from 'react';
import { IonHeader, IonToolbar, IonButtons, IonButton, IonIcon, IonTitle } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { useTranslation } from 'react-i18next';
import { UseFormReturn } from 'react-hook-form';
import { PostFormValues } from '@/hooks/post/usePostForm';

type PostModalHeaderProps = {
  form: UseFormReturn<PostFormValues>;
  onClose: () => void;
  onPublish: () => void;
  media: Array<{ uploading?: boolean }>;
};

export function PostModalHeader({ form, onClose, onPublish, media }: PostModalHeaderProps) {
  const { t } = useTranslation('MGP');

  const isPublishDisabled = !form.getValues('caption').trim() || media.some(item => item.uploading);

  return (
    <IonHeader className="ion-no-border">
      <IonToolbar color="light">
        <IonButtons slot="start">
          <IonButton onClick={onClose}>
            <IonIcon icon={closeOutline} />
          </IonButton>
        </IonButtons>
        <IonTitle>{t('create_new_post')}</IonTitle>
        <IonButtons slot="end">
          <IonButton
            color="primary"
            shape='round'
            fill='clear'
            disabled={isPublishDisabled}
            onClick={onPublish}
          >
            <span className="text-sm font-semibold p-1">{t('publish')}</span>
          </IonButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
  );
}
